import React,{useState,useEffect} from 'react'
import {animated,useTransition} from 'react-spring'
import styled from 'styled-components'
import {mfetch} from './utils/util'

const SItem = styled(animated.div)`
    background  : #991F23;
    color       : white;
    padding     : 16px;
    border-radius :  10px;
    margin      : 0 0 10px;
    cursor      : pointer;
`

const App = () => {
    const [config,setConfig] = useState({})
    const [branches,setBranches] = useState([])
    const [error,setError] = useState()


    useEffect(()=>{
        const getBranch = async () =>{

            // read config
            let mconfig = await fetch('/config/config.json').then(res=>res.json()).catch(e=>({error:'Config error!'}))
            console.log(mconfig);
            if(mconfig.error){ setError(mconfig.error);  return;}
            setConfig(mconfig)

            // get branches
            const server = mconfig.server
            const branches = await mfetch(server.host+'/api_qapp/listbranch',{
                'client_id'     : server.client,
                'country_code'  : server.country
            })
            if(branches.error || branches.length === 0){setError('No branch available!'); return;}

            const updated = await Promise.all(branches.map(async(item)=>{
                // get individual departments
                let depts = await mfetch(server.host+'/api_qapp/listdepartment',{
                    'client_id'     : server.client,
                    'country_code'  : server.country,
                    'branch_id'     : item?.mid,
                })
                return {...item,...{dept0:depts[0]}}
            }))

            let sorted = [...updated].sort((a,b)=>a?.name?.localeCompare(b?.name))
            navigator.geolocation.getCurrentPosition(loc=>{
                sorted = sorted
                .map(i=>{
                    const distance = calculateDistance(loc.coords.latitude,loc.coords.longitude,parseFloat(i?.latitude),parseFloat(i?.longitude))
                    console.log(i.name,distance);
                    return {...i,...{distance}}
                })
                .sort((a,b)=>a.distance - b.distance)
                setBranches(sorted)
                setError('')
            },err=>{
                console.log(sorted);
                setBranches(sorted)
                setError('')
            })
        }
        getBranch()
    },[])

    const transition = useTransition(branches,{
        key   : i=>i?.mid,
        from  : {opacity:0,y:100},
        enter : i=>i?.dept0?.operation_time?.operate === 'open'? {opacity:1,y:0} : {opacity:0.5,y:0},
        leave : {opacity:0,y:-100},
        trail : 50
    })

    const Item = ({item,style})=>{

        const isOpen  = item?.dept0?.operation_time?.operate === 'open'
        const open    = config?.languages?.open ?? 'Still Issuing'
        const close   = config?.languages?.close ?? 'Closed'
        const string1 = config?.languages?.inqueue ?? 'Currently in queue : '
        const string2 = `${config?.languages?.qstatus ?? 'Queue status : '}${isOpen?open:close}`

        return <SItem style={style}
            onClick={()=>{ if(isOpen) window.open(item?.cust_portal_url, '_blank'); }}
            >
            <div style={{fontSize:24,fontWeight:'bold'}}>{item.name}</div>
            {isOpen&&<div style={{fontSize:13}}>{string1}{item?.dept0?.dept_total_wait ?? '-'}</div>}
            <div style={{fontSize:13}}>{string2}</div>
        </SItem>
    }

    return <>
        <div style={{width:'100%',height:70,background:'black',display:'flex',justifyContent:'center'}}>
            <img style={{height:50,margin:'10px auto'}} src={`images/logo-top.png`}/>
        </div>
        <img style={{width:200,height:200,margin:20}} src={`images/logo.png`} onClick={()=>{setBranches([{x:1},{x:2}])}}/>
        <div style={{width:'100%',maxWidth:340,padding:'0 10px'}}>
        { transition((style,item)=><Item item={item} style={style} />) }
        </div>
        <div>{error}</div>
        <div style={{position:'fixed',bottom:0,right:0,fontSize:8,margin:6}}>v1.1</div>
    </>
}



export const calculateDistance = (lat,lng,lat2,lng2) => {
    //https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
    if(isNaN(lat2)) lat2 = 0
    if(isNaN(lng2)) lng2 = 0
    const toRad  = i => i*Math.PI/180
    const rlad   = toRad(lat)
    const rlad2  = toRad(lat2)
    const rtheta = toRad(lng2 - lng)
    let dist     = Math.sin(rlad) * Math.sin(rlad2) + Math.cos(rlad) * Math.cos(rlad2) * Math.cos(rtheta)
    if(dist>1) dist = 1
    dist = Math.acos(dist)
    dist = (dist * 180) / Math.PI
    dist = dist * 60 * 1.1515
    return dist * 1.609344 //convert to km
}


export default App;
